module.exports = __webpack_public_path__ + "media/images/test_product_image-2d1861b8692d4348ef417d087caf4e9f.jpg";